import React from 'react'
import IntegrationsSettings from '@/components/settings/IntegrationsSettings'

const Integrations = () => {
	return <IntegrationsSettings />
}

export default Integrations